import { useContext } from 'react';

import { ApolloError } from '@apollo/client';

import useLocalStorage from '../../hooks/useLocalStorage';
import { AppContext } from '../../store/appContext';
import { Site } from '../../store/types';
import { useService } from '../../store/useService';
import { isZhyRegion, sortByLabel } from '../Utils/Utils';
import { GET_SITES } from './GetSitesService';
import sitesCn from './sites-cn.json';

export function transformDataForDropdown(locationResponse: any): any {
  const locationData: { label: any; value: any; locationId: any }[] = [];
  Object.keys(locationResponse).forEach((loc) => {
    locationData.push({
      label: locationResponse[loc].locationName,
      value: locationResponse[loc].locationName,
      locationId: locationResponse[loc].locationId,
    });
  });
  return locationData.sort(sortByLabel);
}

interface useGetSitesProps {
  onCompleted?: (locations: Site[]) => void;
}

export const useGetSites = ({ onCompleted }: useGetSitesProps) => {
  const [locationStore, setLocationStore] = useLocalStorage('locationStore');
  const appContext = useContext(AppContext);
  const zhyRegion = isZhyRegion(appContext.appType);
  const { useLazyQuery } = useService();
  const [getSites, { loading, error, called, data }] = useLazyQuery(GET_SITES, {
    fetchPolicy: 'cache-first',
    onCompleted: (data) => {
      let locations = transformDataForDropdown(data?.getSites?.sites);
      setLocationStore(locations);
      onCompleted && onCompleted(locations);
    },
    onError: (error: ApolloError) => {
      // ZHY sites are hardcoded for now since CMS is not in ZHY
      console.error(JSON.stringify(error))
      if (zhyRegion) {
        console.error(
          'Error getting sites for us-west-2 and the current region is cn-northwest-1. Getting sites for zhy',
        );
        let zhyLocations = transformDataForDropdown(sitesCn);
        setLocationStore(zhyLocations);
        onCompleted && onCompleted(zhyLocations);
      } else {
        console.error('region is not cn-northwest-1 and GraphQL errored.', error);
        setLocationStore(null);
        onCompleted && onCompleted([]);
      }
    },
  });

  return {
    getSites,
    called,
    loading,
    error,
    data,
    locations: locationStore,
  };
};

export default useGetSites;
